// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"ceae1c3f","239":"e39fb35b","455":"7fe8c6c0","726":"3f3bafb2","775":"a97c6b8b","946":"f8ee8edc"}[chunkId] + ".chunk.js";
};